import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FiHome, FiFolder, FiUser, FiMail, FiMenu } from "react-icons/fi";
import { useNav } from "../context/NavContext";
import styles from "../style/bottomNav.module.css";

const BottomNav = () => {
  const { navOpen, toggleNav, closeAllMenus } = useNav();
  const { pathname } = useLocation();

  const isProjectsActive =
    pathname === "/projects" || pathname.startsWith("/projects/");

  const linkClass = (isActive) =>
    `${styles.bottomNavLink}${isActive ? " active" : ""}`;

  return (
    <nav className="bottom-nav text-light" aria-label="Site navigation">
      <div className="container page-shell">
        <div className={styles.bottomNavInner}>
          <NavLink
            end
            to="/"
            className={({ isActive }) => linkClass(isActive)}
            onClick={closeAllMenus}
          >
            <FiHome className={styles.bottomNavIcon} aria-hidden="true" />
            <span>Home</span>
          </NavLink>

          <NavLink
            to="/about"
            className={({ isActive }) => linkClass(isActive)}
            onClick={closeAllMenus}
          >
            <FiUser className={styles.bottomNavIcon} aria-hidden="true" />
            <span>About</span>
          </NavLink>

          <NavLink
            to="/projects"
            className={() => linkClass(isProjectsActive)}
            onClick={closeAllMenus}
            aria-current={isProjectsActive ? "page" : undefined}
          >
            <FiFolder className={styles.bottomNavIcon} aria-hidden="true" />
            <span>Projects</span>
          </NavLink>

          <NavLink
            to="/contact"
            className={({ isActive }) => linkClass(isActive)}
            onClick={closeAllMenus}
          >
            <FiMail className={styles.bottomNavIcon} aria-hidden="true" />
            <span>Contact</span>
          </NavLink>

          <button
            type="button"
            className={linkClass(navOpen)}
            aria-label={navOpen ? "Close menu" : "Open menu"}
            aria-controls="nav-drawer"
            aria-expanded={navOpen}
            onClick={toggleNav}
          >
            <FiMenu className={styles.bottomNavIcon} aria-hidden="true" />
            <span>More</span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default BottomNav;
